// Vendor imports
const { connect } = require('react-redux')
// Sibling imports
const SearchDomainHeader = require('./component-dumb')

function mapStateToProps(state) {
  return {
    domain: state.query.decoded
  }
}

module.exports = connect(
  mapStateToProps
)(
  SearchDomainHeader
)
